import {
  Accordion,
  Card,
  Divider,
  Flex,
  Modal,
  Stack,
  Text
} from '@mantine/core';
import PropTypes from 'prop-types';
import React from 'react';
import Button from '../../components/elements/Button';
import IconFailed from '../../components/icons/IconFailed';
import IconSuccess from '../../components/icons/IconSuccess';
import styles from './styles.scoped.css';

function RenderModal({
  variant,
  opened,
  handleCloseModal,
  data,
  message,
}) {

  const modalVariant = {
    success: {
      title: 'Unggah Berhasil',
      divider: false,
      content: <Stack align="center">
        <Button fullWidth onClick={handleCloseModal}>
          Tutup
        </Button>
      </Stack>
    },
    failed: {
      title: 'Unggah Gagal',
      divider: true,
      content: <Stack align="center">
        <Text>{message}</Text>
        <Button fullWidth onClick={handleCloseModal}>
          Tutup
        </Button>
      </Stack>
    },
    reason: {
      title: 'File Berhasil Diunggah, Periksa Status Aktivasi Menu GI/GR Pangkalan Di Bawah',
      size: 'lg',
      divider: true,
      content: (
        <Flex direction="column" gap="md">
          <Card p="sm" radius="md" sx={{ padding: '10px' }} withBorder>
            <Flex align="center" direction="row" gap="sm" pl={10}>
              <IconSuccess type={'small'} />
              <Text>
                {data?.successTotal} Pangkalan Berhasil Aktivasi Menu GI/GR
              </Text>
            </Flex>
          </Card>
          <Accordion radius="md" variant="contained">
            <Accordion.Item value="print">
              <Accordion.Control icon={<IconFailed type={'small'} />} py=".2rem">
                {data?.failedTotal} Pangkalan Gagal Aktivasi Menu GI/GR
              </Accordion.Control>
              <Accordion.Panel mx="sm" sx={{ borderTop: '1px solid #D9DEE4' }}>
                {data?.failedDetails?.map((item, index) => (
                  <Flex gap={8} justify={'space-between'} key={index} mt="sm">
                    <Text fz={14}>ID Pangkalan {item.registrationId}</Text>
                    <Text fz={14} sx={{ color: '#CF212A' }}>{item.error}</Text>
                  </Flex>
                ))}
              </Accordion.Panel>
            </Accordion.Item>
          </Accordion>
          <Button fullWidth onClick={handleCloseModal} >
            Tutup
          </Button>
        </Flex>
      )
    }
  };

  return (
    <Modal centered onClose={handleCloseModal} opened={opened} size={modalVariant[variant]?.size || 'lg'}>
      <div className={styles.container}>
        <div className={styles.header}>
          <Text align="center" component="h3" fw={'normal'} fz={24} my={0}>
            {modalVariant[variant]?.title}
          </Text>
          {modalVariant[variant]?.divider && (
            <Divider
              align="center"
              color="#5E811E"
              size={'xl'}
              w={100}
            />
          )}
        </div>
        <div>{modalVariant[variant]?.content}</div>
      </div>
    </Modal>
  );
}

export default RenderModal;
RenderModal.propTypes = {
  data: PropTypes.object,
  editName: PropTypes.string,
  errorEditBusinessType: PropTypes.string,
  handleCloseModal: PropTypes.func,
  handleReset: PropTypes.func,
  handleSubmit: PropTypes.func,
  message: PropTypes.string,
  opened: PropTypes.bool,
  setEditName: PropTypes.string,
  variant: PropTypes.oneOf(['edit', 'add']),
};
